import { Button } from '@mui/material';
import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { LanguageSwitch } from 'components/LanguageSwitch';
import LoadingAnimation from 'components/LoadingAnimation';
import OtpAnimation from 'components/OtpAnimation';
import { observer } from 'mobx-react';
import React from 'react';
import OtpInput from 'react-otp-input';
import { useStores } from 'stores/storeInitializer';
import { MTypography } from '../../../../components/MTypography';
import './index.css';

const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`;
};

export const OtpGuard: React.FC = observer(() => {
    const { store } = useStores();

    React.useEffect(() => {
        if (store.token && store.token?.length === 6) {
            store.triggerActivity(true);
            store.setCount(store.count + 1);
        }
    }, [store, store.token]);

    return (
        <div className="otp-guard-container">
            <OtpAnimation />
            <LanguageSwitch />
            <div className="otp-input-container">
                <MTypography
                    variant="h4"
                    style={{
                        padding: '2%',
                        fontSize: '1.2em',
                        fontWeight: 600,
                    }}
                >
                    {LocalizationKeys.WelcomeMessage}
                </MTypography>
                <MTypography
                    variant="h5"
                    style={{ padding: '5%', fontSize: '1em' }}
                >
                    {LocalizationKeys.EnterOtpMessage}
                </MTypography>
                <OtpInput
                    value={store.token || undefined}
                    onChange={(e) => {
                        store.setToken(e);
                    }}
                    numInputs={6}
                    renderSeparator={<div className="otp-separator"> - </div>}
                    renderInput={(props) => (
                        <input
                            onFocusCapture={(e) => {}}
                            {...props}
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            style={{
                                width: '10%',
                                padding: 0,
                                transform: 'scale(1.3)',
                                fontSize: '2rem',
                                textAlign: 'center',
                            }}
                        />
                    )}
                />
                <div
                    style={{
                        padding: '10%',
                        width: '100%',
                        height: '15vmin',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        onClick={() => store.setCount(store.count + 1)}
                        disabled={store.timer > 0}
                    >
                        <MTypography mr={0.5}>
                            {LocalizationKeys.ResendOtp}
                        </MTypography>
                        {store.timer > 0 ? `(${formatTime(store.timer)})` : ''}
                    </Button>
                </div>
                {store.activity && (
                    <LoadingAnimation
                        hideBarIndicator
                        sx={{
                            position: 'absolute',
                            height: '100%',
                            width: '100%',
                            top: 0,
                            left: 0,
                            backdropFilter: 'blur(2px)',
                        }}
                    />
                )}
            </div>
        </div>
    );
});
